import { toast } from 'sonner';

import {
    useGetCustomerByIdQuery,
    useUpdateCustomerByIdMutation,
} from '@/features/slice/customers/customer-api-slice';
import { useModal } from '@/hooks';
import { TCustomerForm } from '@/modules/customers';
import { toastError } from '@/utils';

export const useUpdateCustomer = () => {
    const { closeModal, modalData: customerId } = useModal();

    const { data, isError, isLoading } = useGetCustomerByIdQuery(customerId);

    const [updateCustomerById, { isLoading: isUpdating }] =
        useUpdateCustomerByIdMutation();

    const onSubmit = async (values: TCustomerForm) => {
        const payload = {
            id: customerId,
            ...values,
        };
        try {
            await updateCustomerById(payload).unwrap();
            closeModal();
            toast.success('Customer created successfully');
        } catch (error) {
            toastError(error, 'useCreateCustomer: onSubmit');
        }
    };

    return {
        data,
        isUpdating,
        onSubmit,
        isLoading,
        isError,
        closeModal,
    };
};
